import { useImmer } from "use-immer";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import UtilService from "../../service/UtilService";

const Component = ({ config, onChange }) => {
  const [data, updateData] = useImmer(config);

  useEffect(() => {
    updateData(config);
  }, [config]);

  useEffect(() => {
    onChange(data);
  }, [data]);

  return (
    <>
      <table className="config-table">
        <thead>
        <tr>
          <th>Attribute</th>
          <th>Value</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>Reject reason codes</td>
          <td>
            <input
              type="text"
              value={UtilService.arrayToCsv(data.rejectReasonCodes || [])}
              onChange={(e) =>
                updateData((d) => {
                  d.rejectReasonCodes = UtilService.csvToStringArray(
                    e.target.value,
                  );
                })
              }
            />
          </td>
        </tr>
        <tr>
          <td>Score Increase (% over Recent Hotspot)</td>
          <td>
            <div style={{display: 'flex', alignItems: 'center', gap: '5px'}}>
              <input
                type="number"
                step="1"
                min="0"
                max="100"
                value={data.immediateHotspotScore}
                onChange={(e) =>
                  updateData((d) => {
                    d.immediateHotspotScore = e.target.value;
                  })
                }
              />
            </div>
          </td>
        </tr>
        <tr>
          <td>Immediate Hotspot Duration (minutes)</td>
          <td>
            <input
              type="number"
              value={data.immediateHotspotDurationMinutes}
              onChange={(e) =>
                updateData((d) => {
                  d.immediateHotspotDurationMinutes = e.target.value;
                })
              }
            />
          </td>
        </tr>
        <tr>
          <td>Successful Refueling Window (minutes)</td>
          <td>
            <input
              type="number"
              value={data.successfulRefuelingWindowMinutes}
              onChange={(e) =>
                updateData((d) => {
                  d.successfulRefuelingWindowMinutes = e.target.value;
                })
              }
            />
          </td>
        </tr>
        </tbody>
      </table>
      <Link to="/config/hotspot">View detail</Link>
    </>
  );
};

export default Component;
